import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

// Bearer fallback for browsers that block cross-site cookies (e.g. Safari, custom domains).
const TOKEN_KEY = "wis_token";
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use((res) => {
  if (res.data && typeof res.data === "object" && typeof res.data.token === "string") {
    setToken(res.data.token);
    delete res.data.token;
  }
  return res;
});

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (!e?.response) return "No connection. Please check your internet.";
  return fallback;
};
